@if (!editMode) {
  <div>
    <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:my-2">
      <div class="tw:w-auto tw:px-[15px]">
        <div class="kvp__k tw:py-1">Learners Current Progress:</div>
        <div class="kvp__k tw:py-1">Progression Comments:</div>
      </div>
      <div class="tw:flex-1 tw:px-[15px]">
        <div class="kvp__v tw:py-1">{{ timelineSection.currentProgress }} &nbsp;</div>
        <div class="kvp__v tw:py-1">{{ timelineSection.progressComments }} &nbsp;</div>
      </div>
    </div>
  </div>
}


@if (editMode) {
  <div>
    <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:mb-12">
      <div class="tw:w-1/2 tw:px-[15px]">
        <label class="field__label">Learners Current Progress:</label>
        <select class="field__control" [(ngModel)]="timelineSection.currentProgress" name="currentProgress" [disabled]="!isFormEditable()">
          @for (progress of progressList; track progress) {
            <option [ngValue]="progress.text">{{progress.text}}</option>
          }
        </select>
      </div>
      <div class="tw:w-1/2 tw:px-[15px]">
        {{ learnerJourneyDescription() }}
      </div>
    </div>
    <div class="tw:flex tw:flex-wrap tw:-mx-[15px]">
      <div class="tw:w-full tw:px-[15px]">
        <label class="field__label">Progression Comments:</label>
        <textarea required #lessonSummary
          class="field__control"
          [(ngModel)]="timelineSection.progressComments"
          [disabled]="!isFormEditable()"
          name="comments"
          rows="7"
          maxlength="3000"></textarea>
        <span class="field__hint tw:block tw:text-right">{{ timelineSection.progressComments?.length || 0 }}/3000</span>
      </div>
    </div>
  </div>
}
